import { TFunction } from "i18next";

import {
	COMPANY_CONTACT_LOOKUP_CREDITS,
	DEEP_RESEARCH_LEAD_CREDITS,
	EMAIL_LOOKUP_CREDITS,
	PHONE_LOOKUP_CREDITS,
	RESCORE_LEAD_CREDITS,
} from "@signalist/shared-types";

import { formatCredits } from "./creditBreakdown";

/** The price each Enrich menu item names: the shared constant the API charges (PREC-4263). */
export const CREDIT_MENU_PRICES = {
	email: EMAIL_LOOKUP_CREDITS,
	phone: PHONE_LOOKUP_CREDITS,
	companyContact: COMPANY_CONTACT_LOOKUP_CREDITS,
	rescore: RESCORE_LEAD_CREDITS,
	deepResearch: DEEP_RESEARCH_LEAD_CREDITS,
} as const;

/** "1 credit per email found", "0.2 credits per rescored lead": the menu subtitle of an action. */
export const creditMenuSubtitle = (t: TFunction, action: keyof typeof CREDIT_MENU_PRICES): string =>
	t(`creditConfirm.menu.${action}`, {
		count: CREDIT_MENU_PRICES[action],
		credits: formatCredits(CREDIT_MENU_PRICES[action]),
	});
